export enum UserEvent {
  LISTING_VISIT = "listing-visit",
  STORE_VISIT = "store-visit",
  CATEGORY_CLICK = "category-click",
  SPECS_CLICK = "specs-click",
  SPECS_CATEGORY_CLICK = "specs-category-click",
  MODEL_VISIT = "model-visit",
  ADD_TO_CART = "add-to-cart",
  BUY_NOW = "buy-now",
  CHECKOUT = "checkout",
  RESERVE = "reserve",
  CONTACT_WHATSAPP = "contact-whatsapp",
  CONTACT_PHONE = "contact-phone",
  OTP_VERIFIED = "otp-verified",
  OTP_SENT = "otp-sent",
  
}

export enum LeadType {
  PHONE = "phone",
  WHATSAPP = "whatsapp",
}
